// extracted by mini-css-extract-plugin
module.exports = {"container":"Flow_container_24LjE","component":"Flow_component_2mqrW"};